import { useLocale } from "next-intl";

export const BREAKPOINT = {
  xs: 375,
  sm: 768,
  md: 996,
  lg: 1200,
  xl: 1440,
};

export const RTLlanguagesLocale = ["he", "ar", "fa"];
